import React, { useEffect, useState } from 'react';
import { dispatchService } from '../../../services/central-api/dispatch';
import { translate } from '../../../services/translate';
import { UseFormReturn } from 'react-hook-form';
import FormDropDownPicker from '../../../components/FormDropDownPicker';
import FilterDropdown from '../../../components/Filter/components/FilterDropdown';

type Props = {
    zIndex: number;
    disabled?: boolean;
    includeAllOption: boolean;
    required?: boolean;
} & ({
    form?: undefined;
    fieldName?: undefined;
    customValidations?: undefined;
    pattern?: undefined;
    value: number;
    setValue: React.Dispatch<React.SetStateAction<number>>;
} | {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    form: UseFormReturn<any, any, any>;
    fieldName: string;
    value?: undefined;
    setValue?: undefined;
});

function ActingBodiesDropdown({ value, setValue, form, fieldName, zIndex, disabled, includeAllOption, required }: Props) {
    const [selectableActingBodies, setSelectableActingBodies] = useState<{ label: string; value: number; }[]>([]);

    async function getActingBodies() {
        try {
            const actingBodies = await dispatchService.getActingBodies();
            setSelectableActingBodies([
                ...(includeAllOption ? [{ value: 0, label: translate('masculineAll') }] : []),
                ...actingBodies.map((actingBody) => {
                    return {
                        value: actingBody.id,
                        label: actingBody.name
                    };
                })
            ]);
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        getActingBodies();
    }, []);

    if (form && fieldName) {
        return (
            <FormDropDownPicker
                label={translate('actingBody')}
                items={selectableActingBodies}
                multiple={false}
                fieldName={fieldName}
                form={form}
                zIndex={zIndex}
                disabled={disabled}
                required={required}
            />
        );
    } else if (value !== undefined && setValue !== undefined) {
        return (
            <FilterDropdown
                label={translate('actingBody')}
                items={selectableActingBodies}
                multiple={false}
                setValue={setValue}
                value={value}
                zIndex={zIndex}
                disabled={disabled}
                required={required}
            />
        );
    }
}

export default ActingBodiesDropdown;
